<script>
  import AXHR from "../js/axhr.js";
  import { session } from "../js/store.js";
  import { onInterval } from "../js/intervall.js";
  let sessions;
  $: sessions;
  session.subscribe((value) => {
    sessions = value;
  });
  import { chart } from "svelte-apexcharts";
  var options = {
    series: [
      {
        name: "Tx",
        data: [1],
      },
      {
        name: "Rx",
        data: [1],
      },
    ],
    xaxis: {
      type: "datetime",
      categories: [
        new Date(new Date().toString().split("GMT")[0] + " UTC").toISOString(),
      ],
    },
    yaxis: {
      show: false,
      labels: {
        formatter: (y) => {
          let bytes = y;
          let sizes = ["bps", "kbps", "Mbps", "Gbps", "Tbps"];
          if (bytes == 0) return "0 bps";
          let i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)));
          return (
            parseFloat((bytes / Math.pow(1024, i)).toFixed(2)) + " " + sizes[i]
          );
        },
      },
    },
    tooltip: {
      x: {
        format: "HH:mm:ss",
      },
      shared: true,
      intersect: false,
      y: {
        formatter: function (y) {
          let bytes = y;
          let sizes = ["bps", "kbps", "Mbps", "Gbps", "Tbps"];
          if (bytes == 0) return "0 bps";
          let i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)));
          return (
            parseFloat((bytes / Math.pow(1024, i)).toFixed(2)) + " " + sizes[i]
          );
        },
      },
    },
    chart: {
      height: 415,
      type: "area",
      stacked: false,
      toolbar: {
        show: false,
      },
    },
    title: {
      text: undefined,
      align: "center",
      margin: 10,
      offsetX: 0,
      offsetY: 0,
      floating: false,
      style: {
        fontSize: "14px",
        fontWeight: "normal",
        fontFamily: "Rubik, sans-serif",
        color: "#263238",
      },
    },
    dataLabels: {
      enabled: false,
    },
    stroke: {
      curve: "smooth",
    },
    fill: {
      type: "gradient",
      gradient: {
        shadeIntensity: 1,
        opacityFrom: 0.7,
        opacityTo: 0.9,
        stops: [0, 100],
      },
    },
  };

  let errorEvent = 0;
  let nextInterval = true;

  function loadTraffictData(endpoint, token, inface = "ether1") {
    if (errorEvent < 1) {
      var data = { iface: inface };
      var config = {
        method: "post",
        url: endpoint,
        headers: {
          Authorization: "Bearer " + token,
        },
        data: data,
      };

      AXHR(config)
        .then(function (response) {
          nextInterval = true;
          errorEvent = 0;
          var dt = new Date(
            new Date().toString().split("GMT")[0] + " UTC"
          ).toISOString();
          options.series[0].data = [
            ...options.series[0].data,
            parseFloat(response.data.txBitsPerSecond),
          ];
          options.series[1].data = [
            ...options.series[1].data,
            parseFloat(response.data.rxBitsPerSecond),
          ];
          options.title.text = response.data.name + " Traffic";
          options.xaxis.categories = [...options.xaxis.categories, dt];
        })
        .catch(function (error) {
          nextInterval = false;
          errorEvent = errorEvent + 1;
        });
    }
  }
  function tryloadTraffictData() {
    console.log("triggered");
    errorEvent = 0;
    loadTraffictData(
      sessions.api + "/rb/" + sessions.routeractive.id + "/stream",
      sessions.token,
      sessions.routeractive.iface
    );
  }
  const tryload = tryloadTraffictData();
  $: if (nextInterval) {
    onInterval(() => {
      loadTraffictData(
        sessions.api + "/rb/" + sessions.routeractive.id + "/stream",
        sessions.token,
        sessions.routeractive.iface
      );
    }, 10000);
  }
</script>

<div class="relative py-5 my-5 bg-white rounded-lg shadow-lg">
  <h2 class="text-sm font-bold text-center">Traffic Monitor</h2>
  {#if nextInterval == false}
    <div class="w-full p-5">
      <div
        class="p-2 mx-2 text-xs text-center text-gray-700 bg-yellow-500 rounded-lg"
      >
        If your selected iface <b>({sessions.routeractive.iface})</b>
        does not shown traffict, please check typo of your iface settings.
        <span
          class="text-red-700 cursor-pointer"
          on:click={() => tryloadTraffictData()}>try load manual</span
        >
      </div>
    </div>
  {/if}
  <div use:chart={options} />
</div>
